import angular from 'angular';
import { MeurhBeneficiosSuspensaoFormController } from './suspensao.form.controller';

export class MeurhBeneficiosSuspensaoFormComponent implements angular.IComponentOptions {
    static selector = 'meurhBeneficiosSuspensaoFormComponent';
    static controller = MeurhBeneficiosSuspensaoFormController;
    static template = require('!!html-loader!./suspensao.form.html');
    static transclude = true;
    static bindings = {
        tipoBeneficio: '<',
        limitDate: '<?',
        entity: '=',
        form: '<?',
        editable: '<'
    };
}
